// v2 campaign catalog lane — owned by the same agent as app/v2/kit.tsx. Do not edit
// from another lane. One entry per shipped v2 page.
import type { V2CatalogEntry } from './types';

export const kitCatalog: V2CatalogEntry[] = [
  {
    rank: 1,
    title: 'Work Pool',
    route: '/manage/work-pool2',
    faithfulRoute: '/manage/work-pool',
    score: 20,
    blurb:
      'Pool health up front — unassigned, calc errors, conflicts and the oldest open task — with a rail that filters the same rows by question and one action button that names the confirm window the focused row opens.',
  },
];
